// extracted by mini-css-extract-plugin
export var header = "Team-module--header--S3b7N";
export var list = "Team-module--list--OIU5D";